<template>
  <el-row>
    <el-row class="pb-3">
      <el-col>
        <el-card shadow="never">
          <OpportunitySteps :opportunity="opportunity" />
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="15">
      <el-col :span="10">
        <el-card
          header="Key Fields"
          shadow="never"
        >
          <PeekKeyFields :opportunity="opportunity" />
        </el-card>
      </el-col>

      <el-col :span="14">
        <el-card
          shadow="never"
          class="mb-3"
        >
          <template #header>
            Events
            <el-button
              type="text"
              @click.native="createEvent"
            >
              New Event
            </el-button>
          </template>
          <Events :account-id="$_.get(opportunity, 'account.id')" />
        </el-card>

        <el-card shadow="never">
          <template #header>
            Notes
            <el-button
              type="text"
              @click.native="() => $refs.notes.create()"
            >
              Add Note
            </el-button>
          </template>

          <Notes
            ref="notes"
            :resource="opportunity.account"
            truncate
            paginate
            pagination-layout="prev, pager, next"
            :limit="3"
          />
        </el-card>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import OpportunitySteps from '@/components/Application/Sales/Opportunities/Opportunity/Steps'
import PeekKeyFields from '@/components/Application/Sales/Opportunities/Opportunity/Peek/KeyFields'
import Events from '@/components/Application/Sales/Opportunities/Opportunity/Peek/Events'
import Notes from '@/components/Notes'
import EventFormDialog from '@/components/Application/Sales/Events/Event/CreateDialog'
import Vue from 'vue'

export default {
  components: {
    OpportunitySteps,
    PeekKeyFields,
    Events,
    Notes
  },
  props: {
    opportunity: {
      type: Object,
      required: true
    }
  },
  methods: {
    createEvent () {
      const EventFormDialogClass = Vue.extend(EventFormDialog)
      const propsData = { event: new this.$sdk.account_event() }
      propsData.event.account = this.opportunity.account

      propsData.disabledFields = [
        'account'
      ]

      this.eventFormDialogInstance = new EventFormDialogClass({
        propsData
      })

      this
        .eventFormDialogInstance
        .$on('destroy', () => {
          this.eventFormDialogVisible = false
        })

      this
        .eventFormDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.eventFormDialogInstance.$el)

      this.eventFormDialogVisible = true
    }
  }
}
</script>
